type Display3 = {
    fontFamily: any;
    fontWeight: any;
    fontStyle: any;
    fontSize: any;
    letterSpacing: any;
    lineHeight: any;
};

export const display3: Display3 = {
    'fontFamily': 'var(--plasma-typo-display3-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-display3-font-weight, 500)',
    'fontStyle': 'var(--plasma-typo-display3-font-style, normal)',
    'fontSize': 'var(--plasma-typo-display3-font-size, 3rem)',
    'letterSpacing': 'var(--plasma-typo-display3-letter-spacing, normal)',
    'lineHeight': 'var(--plasma-typo-display3-line-height, 3.25rem)'
};